module.exports = __webpack_public_path__ + "assets-cabinet/img/accounts-cards-icon.9d6f7c8a.svg";